import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { serialNameFQN3cassnowfodm5 as serialNameFQN } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/SerialDescriptor.ext.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SelectorClass;
function Selector() {
  if (SelectorClass === VOID) {
    class $ {
      constructor(annotation, type, kind) {
        annotation = annotation === VOID ? null : annotation;
        type = type === VOID ? null : type;
        kind = kind === VOID ? null : kind;
        this.annotation_1 = annotation;
        this.type_1 = type;
        this.kind_1 = kind;
      }
      matches_1u0b5c_k$(context) {
        var descriptor = context.serializer_1.get_descriptor_wjt6a0_k$();
        if (!(this.annotation_1 == null) && !context.hasAnnotation_cpsd4h_k$(this.annotation_1))
          return false;
        if (!(this.type_1 == null) && !(serialNameFQN(descriptor) === this.type_1))
          return false;
        if (!(this.kind_1 == null) && !equals(descriptor.get_kind_wop7ml_k$(), this.kind_1))
          return false;
        return true;
      }
      toString() {
        return 'Selector(annotation=' + this.annotation_1 + ', type=' + this.type_1 + ', kind=' + toString(this.kind_1) + ')';
      }
      hashCode() {
        var result = this.annotation_1 == null ? 0 : getStringHashCode(this.annotation_1);
        result = imul(result, 31) + (this.type_1 == null ? 0 : getStringHashCode(this.type_1)) | 0;
        result = imul(result, 31) + (this.kind_1 == null ? 0 : this.kind_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Selector()))
          return false;
        if (!(this.annotation_1 == other.annotation_1))
          return false;
        if (!(this.type_1 == other.type_1))
          return false;
        if (!equals(this.kind_1, other.kind_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Selector', Selector);
    SelectorClass = $;
  }
  return SelectorClass;
}
//region block: exports
export {
  Selector as Selectorispogzpkkfxv,
};
//endregion

//# sourceMappingURL=Selector.mjs.map
